module.exports = __webpack_public_path__ + "static/media/fbeLogo.a4427df0.png";